import ConfirmationContainer from './containers/ConfirmationContainer';

export default ConfirmationContainer;
